module.exports = __webpack_public_path__ + "img/PB_Logo.46921e2.svg";